import { render, staticRenderFns } from "./basic-layers.vue?vue&type=template&id=28cb2930"
import script from "./basic-layers.vue?vue&type=script&lang=js"
export * from "./basic-layers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports